// extracted by mini-css-extract-plugin
export default {"buttonAnswer":"PageItemVideoConversation_buttonAnswer__kexf8"};